import { useMemo } from 'react';

/**
 * Custom hook to determine if the primary input device is a desktop-class pointer.
 *
 * - Uses `window.matchMedia("(pointer: fine)")` to detect precise input devices like a mouse or trackpad.
 * - Returns a boolean (`true` for desktop-like devices, `false` for touch-based devices).
 */
export const useIsDesktop = () => {
  return useMemo(() => {
    return typeof window !== 'undefined' && window.matchMedia('(pointer: fine)').matches;
  }, []);
};
